import { render } from "./CertificateGeneratorTabSelector.vue?vue&type=template&id=aa2c96ca"
import script from "./CertificateGeneratorTabSelector.vue?vue&type=script&lang=js"
export * from "./CertificateGeneratorTabSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__